function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.08,
    y: 1.2,
    width: 11.85,
    height: 10.02,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.85,3.71a2.57,2.57,0,0,1,.7-1.78A2.28,2.28,0,0,1,4.22,1.2a2.32,2.32,0,0,1,1.68.73,2.63,2.63,0,0,1,0,3.55,2.32,2.32,0,0,1-1.68.73,2.28,2.28,0,0,1-1.67-.73A2.56,2.56,0,0,1,1.85,3.71ZM.08,10.64a3.39,3.39,0,0,1,3.3-3.49H5.07a3.4,3.4,0,0,1,3.3,3.49.57.57,0,0,1-.55.58H.63A.56.56,0,0,1,.08,10.64Zm11.57-6L9.28,7.17a.43.43,0,0,1-.63,0L7.46,5.92a.5.5,0,0,1,0-.67.43.43,0,0,1,.63,0L9,6.17,11,4a.42.42,0,0,1,.63,0,.49.49,0,0,1,0,.66Z",
    style: {
      fill: "#32ca73"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/assign_icon.18e5456615e3b6c575150809c6b5abd5.svg";
export { ForwardRef as ReactComponent };